module.exports = __webpack_public_path__ + "static/img/图层11.3e8f208.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层11.png
// module id = 5il9
// module chunks = 0